import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom'
import _ from 'lodash';

import { Grid, Typography, TextField, Button, Link, Paper } from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { WithStyles, createStyles } from '@material-ui/core';

import { RoleData, RolesD } from '../types/UserData';

const styles = (theme: Theme) => createStyles({
  paper: {
    width: '100%',
    height: '100vh',
    overflow: 'auto',
    textAlign: 'center',
    "& img": {
      margin: "0 auto",
    }
  },
  logo: {
    paddingTop: theme.spacing.unit * 6,
  },
  roleContainerTitle: {
    textAlign: "left",
    marginBottom: theme.spacing.unit,
    marginLeft: theme.spacing.unit + theme.spacing.unit / 4
  },
  roleContainer: {
    padding: theme.spacing.unit * 4
  },
  roleBox: {
    maxWidth: '270px',
    margin: '0 auto',
    textAlign: "center",
    padding: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 3,
    borderRadius: theme.spacing.unit + "px",
    cursor: "pointer",
  }
});


const profileImages = [
  "/assets/img/userpersonas/professor.png",
  "/assets/img/userpersonas/boy (1).png",
  "/assets/img/userpersonas/man.png",
  "/assets/img/userpersonas/boy (1).png",
  "/assets/img/userpersonas/boy (1).png",
  "/assets/img/userpersonas/boy (1).png",
  "/assets/img/userpersonas/boy (1).png",
  "/assets/img/userpersonas/boy (1).png",
  "/assets/img/userpersonas/boy (1).png",
  "/assets/img/userpersonas/boy (1).png",
  "/assets/img/userpersonas/woman (1).png",
  "/assets/img/userpersonas/woman.png"
]

//@ts-ignore
interface UserRolesProps extends WithStyles<typeof styles> {
  classes: any,
  roles: RoleData,
  setSelectedRole: Function
}

interface UserRolesState {

}

class UserRoles extends Component<UserRolesProps, UserRolesState> {

  constructor(props: UserRolesProps, state: UserRolesState) {
    super(props)
  }

  render() {

    const { classes, roles, setSelectedRole } = this.props;
    return (
      <Paper className={classes.paper} >
        <Grid container direction="column">
          <Grid item>
            <img src="/assets/img/logo.jpg" className={classes.logo}></img>
          </Grid>
          <Grid item>
            <div className={classes.roleContainer}>
              <Typography variant="h6" className={classes.roleContainerTitle}><strong>Login As</strong></Typography>
              <Grid container>
                {
                  _.map(roles, (r: RolesD, i: number) => (
                    <Grid key={i} item xs={6}>
                      <Paper className={classes.roleBox} onClick={() => setSelectedRole(i)}>
                        <img src={profileImages[i]} />
                        <Typography variant="h6">{r.roleId.role}</Typography>
                      </Paper>
                    </Grid>
                  ))
                }
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

//@ts-ignore
export default withStyles(styles)(UserRoles);